import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wizard-panels" }
const _hoisted_2 = { class: "wizard-panels__left" }
const _hoisted_3 = { class: "list-blocks" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "wizard-panels__right pl-4 pr-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_ElScrollbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_Card, { class: "card--primary" }, {
            content: _withCtx(() => [
              _createVNode("ul", _hoisted_3, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.preferencesList, (p) => {
                  return (_openBlock(), _createBlock("li", {
                    key: p,
                    class: "d-flex align-items-center justify-content-between"
                  }, [
                    _createVNode("h4", _hoisted_4, _toDisplayString(p.label), 1),
                    _createVNode(_component_Button, {
                      onClick: ($event: any) => (_ctx.showSettings(p)),
                      label: _ctx.$t('AppResource.Settings'),
                      class: "p-button-text"
                    }, null, 8, ["onClick", "label"])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.currentPreference)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_ElScrollbar, { class: "pr-3" }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.preferenceComponent), {
                "room-object": _ctx.roomObject,
                "preference-label": _ctx.currentPreference.label
              }, null, 8, ["room-object", "preference-label"]))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}